module.exports = __webpack_public_path__ + "static/media/grass_fed_beef_fr.6b7e6b8a.svg";